import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import { CONDITIONAL_DIFFICULTY, TRACKER_TYPE } from '../../enum-registry.ts';

export const DegenConditionalPoolSchema = defineSchema({
  name: 'serverDegenConditionalPool',
  fields: [
    ['id', 'string'],
    ['bonusPct', 'number'],
    ['selectionWeight', 'number'],
    ['conditionKey', 'string'],
    [
      'difficulty',
      { kind: 'enum', name: 'ConditionalDifficulty', members: CONDITIONAL_DIFFICULTY },
    ],
    ['trackerType', { kind: 'enum', name: 'TrackerType', members: TRACKER_TYPE }],
    ['params', { kind: 'json' }],
  ],
  lookupKeys: ['id'],
});

export interface RawDegenConditionalPoolRow {
  id: string;
  bonus_pct: number;
  selection_weight: number;
  condition_key: string;
  difficulty: string;
  tracker_type: string;
  params: unknown;
}

export function degenConditionalPoolFromRaw(row: RawDegenConditionalPoolRow) {
  return {
    id: row.id,
    bonusPct: row.bonus_pct,
    selectionWeight: row.selection_weight,
    conditionKey: row.condition_key,
    difficulty: row.difficulty,
    trackerType: row.tracker_type,
    params: typeof row.params === 'string' ? JSON.parse(row.params) : row.params,
  };
}

registerCategorySchema('serverDegenConditionalPool', DegenConditionalPoolSchema);
